import React from "react";
import Header from "../Header";
import { Container, Spinner, Tab, Tabs } from "react-bootstrap";
import Footer from "../Footer/Footer";
import Overview from "./Overview";
import Jobs from "./Jobs";
import useOverview from "./Overview/useOverview";
import "./Company.scss";

export default (props) => {
  const { loading, companyInfo } = useOverview();
  return (
    <div className="company-info-wrapper footer-gap">
      <Header />
      {loading ?
        <div className="d-flex justify-content-center align-items-center w-100">
          <Spinner animation="border" variant="primary" />
        </div> :
        <div className="container">
          <h2 className="py-3">{companyInfo?.name}</h2>
        </div>
      }

      <Container className="hiring-process-dashboard mb-5">
        <div className="hiring-board  mt-4 bg-white mb-4 pb-4">
          <div className="panel-right">
            <Tabs defaultActiveKey="Overview" className="bg-grey pt-3">
              <Tab eventKey="Overview" title="Overview">
                <Overview />
              </Tab>
              <Tab eventKey="Jobs" title="Jobs">
                <Jobs />
              </Tab>
            </Tabs>
          </div>
        </div>
      </Container>
      <Footer />
    </div>
  );
};
